import * as $ from 'jquery';
import App from '../app';
import FlashInfoModel from '../../models/flashinfo';
import AppSingleton from '../../services/appSingleton'

export default class FlashInfo {

    private app: App;
    private elementContainer:any;
    private config:any;
    private flashInfos:FlashInfoModel[];
    private enabledFlashInfos:FlashInfoModel[];
    private delay:number = 5000;
    private currentFlashInfo:FlashInfoModel;
    private interval:any;
    private afterLoad:any;

    /**
     * @param elementContainer
     * @param afterLoad
     */
    constructor(elementContainer, afterLoad = function () {}) {
        this.app = AppSingleton.getInstance();
        this.elementContainer = elementContainer;
        this.afterLoad = afterLoad;
        this.config = elementContainer.data('config');

        if ($.isArray(this.config)) {
            this.flashInfos = this.config.map(i => new FlashInfoModel(i));

            this.init();
            this.bindEvents();
        }
    }

    getElementContainer() {
        return this.elementContainer;
    }

    /**
     * Init flash info module
     */
    init() {
        this.enabledFlashInfos = this.getEnabledFlashInfos();

        if (this.enabledFlashInfos.length > 0) {
            this.currentFlashInfo = this.enabledFlashInfos[0];
            this.elementContainer.addClass('active');
        } else {
            this.elementContainer.removeClass('active');
        }

        $(document).ready(() => {
            this.buildHtml(this.enabledFlashInfos.length);
            this.refreshFlashinfoEvent();
            this.processShow();
        });
    }

    /**
     * Build the html of flash infos
     */
    buildHtml(count) {
        this.elementContainer.html('');
        this.enabledFlashInfos.forEach(model => {
            let sizeFixed = false;
            if (this.app.isMobile() && count >= 2) {
                sizeFixed = true;
            }

            this.elementContainer.append(model.getHtml(sizeFixed));
        });
    }

    /**
     * Bind All events of flash infos module
     */
    bindEvents() {
        $(document).on("flashinfo-closed", () => {
            this.flashInfos.forEach(model => model.rebuild());
            this.elementContainer.removeClass('active');
            clearInterval(this.interval);
            setTimeout(() => {
                this.init()
            }, 1000);
        });

        setInterval(() => {
            this.afterLoad();
        }, 500);
    }

    /**
     * Create the interval who show flash infos
     */
    refreshFlashinfoEvent() {
        if (this.enabledFlashInfos.length > 1) {
            this.interval = setInterval(() => {
                if (!this.elementContainer.is(':hover')) {
                    this.processShow();
                }
            }, this.delay);
        } else {
            this.processShow();
        }
    }

    /**
     * Check and show the next flash info
     */
    processShow() {
        this.currentFlashInfo = this.getNextFlashInfo();

        if (this.currentFlashInfo) {
            this.elementContainer.children().addClass('inactive');

            setTimeout(() => {
                this.elementContainer.children().removeClass('active').removeClass('inactive');
                this.findFlashInfoHtmlById(this.currentFlashInfo.getId()).addClass('active');
                this.afterLoad();
            }, 500);
        }
    }

    /**
     * @param id
     * @returns {any}
     */
    findFlashInfoHtmlById(id:number) {
        let element:any = null;

        this.elementContainer.children().each(function () {
            if ($(this).data('id') == id) {
                element = $(this);
            }
        });

        return element;
    }

    /**
     * @returns {FlashInfoModel}
     */
    getNextFlashInfo() {
        if (this.enabledFlashInfos.length === 0) {
            return null;
        }

        let currentIndex = this.enabledFlashInfos.indexOf(this.currentFlashInfo);

        if (currentIndex === -1) {
            return this.enabledFlashInfos[0];
        }

        return this.enabledFlashInfos.hasOwnProperty(currentIndex + 1)
            ? this.enabledFlashInfos[currentIndex + 1]
            : this.enabledFlashInfos[0];
    }

    /**
     * @returns {FlashInfoModel[]}
     */
    getEnabledFlashInfos() {
        const enabledFlashInfos = [];

        this.flashInfos.forEach((model:FlashInfoModel) => {
            if (model.isEnable()) {
                enabledFlashInfos.push(model);
            }
        });

        return enabledFlashInfos;
    }
}